<template>
  <div v-if="!item.hidden">
    <template v-if="shouldRenderSingleChild">
      <app-link v-if="onlyOneChild.meta" :to="onlyOneChild.resolvedPath">
        <el-menu-item 
          :index="onlyOneChild.resolvedPath" 
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item 
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" 
            :title="onlyOneChild.meta.title" 
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else-if="hasVisibleChildren" :index="resolvePath(item.path)" popper-append-to-body>
      <template #title>
        <item v-if="item.meta" :icon="item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in visibleChildren"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-submenu>
  </div>
</template>

<script>
import { isExternal } from '@/utils/validate'
import Item from './Item.vue'
import AppLink from './Link.vue'

  export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    props: {
      item: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        default: false
      },
      basePath: {
        type: String,
        default: ''
      },
      isCollapse: {
        type: Boolean,
        default: false
      }
    },
    computed: {
    visibleChildren() {
      const children = this.item && this.item.children ? this.item.children : []
      return children.filter(c => !c.hidden)
    },
    hasVisibleChildren() {
      return this.visibleChildren.length > 0
    },
    shouldRenderSingleChild() {
      if (!this.item.children || this.item.children.length === 0) {
        return false
      }
      const showingChildren = this.visibleChildren
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },

    onlyOneChild() {
      if (!this.item.children || this.item.children.length === 0) {
        return {}
      }
      const showingChildren = this.visibleChildren
      if (showingChildren.length === 1) {
        const child = { ...showingChildren[0] }
        child.resolvedPath = this.resolvePath(child.path)
        return child
      }
      return {}
    }
  },
  methods: {
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      
      if (this.basePath && !routePath.startsWith('/')) {
        const cleanBase = this.basePath.endsWith('/') ? this.basePath.slice(0, -1) : this.basePath;
        const cleanRoute = routePath.startsWith('/') ? routePath.slice(1) : routePath;
        return `${cleanBase}/${cleanRoute}`;
      }
      
      return routePath;
    }
  }
}
</script>
